import React, { Fragment } from 'react'
import NavBarLandingPage from '../NavBarLandingPage'
import FAQ from './FAQ'
import FooterLandingpage from '../FooterLandingpage'
import './referAndEarn.css'
import ReferAndEarnHero from './ReferAndEarnHero'
import { Box } from '@mui/material'
import ReferEarnHowItWorks from './ReferEarnHowItWorks'
import ReferEarnKeyBenefits from './ReferEarnKeyBenefits'

function ReferAndEarnIndex() {
    return (
        <Fragment>
            <Box>

            <NavBarLandingPage />
            </Box>
            {/* <Container maxWidth={false} > */}
            <ReferAndEarnHero />
            <ReferEarnHowItWorks />
            <ReferEarnKeyBenefits/>

            <FAQ />


            {/* </Container> */}
            <FooterLandingpage />
        </Fragment>
    )
}

export default ReferAndEarnIndex
